import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Location from '../geom/Location';
import hasInterface from '../../../../hasInterface';
import Coordinate from '../geom/Coordinate';
import CoordinateSequence from '../geom/CoordinateSequence';
import RobustLineIntersector from './RobustLineIntersector';
import RayCrossingCounter from './RayCrossingCounter';
var PointLocation = /*#__PURE__*/function () {
  function PointLocation() {
    _classCallCheck(this, PointLocation);
  }
  _createClass(PointLocation, null, [{
    key: "isOnLine",
    value: function isOnLine() {
      if (arguments[0] instanceof Coordinate && hasInterface(arguments[1], CoordinateSequence)) {
        var p = arguments[0],
          line = arguments[1];
        var lineIntersector = new RobustLineIntersector();
        var p0 = new Coordinate();
        var p1 = new Coordinate();
        var n = line.size();
        for (var i = 1; i < n; i++) {
          line.getCoordinate(i - 1, p0);
          line.getCoordinate(i, p1);
          lineIntersector.computeIntersection(p, p0, p1);
          if (lineIntersector.hasIntersection()) return true;
        }
        return false;
      } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Array) {
        var _p = arguments[0],
          _line = arguments[1];
        var _lineIntersector = new RobustLineIntersector();
        for (var _i = 1; _i < _line.length; _i++) {
          var _p2 = _line[_i - 1];
          var _p3 = _line[_i];
          _lineIntersector.computeIntersection(_p, _p2, _p3);
          if (_lineIntersector.hasIntersection()) return true;
        }
        return false;
      }
    }
  }, {
    key: "locateInRing",
    value: function locateInRing(p, ring) {
      return RayCrossingCounter.locatePointInRing(p, ring);
    }
  }, {
    key: "isInRing",
    value: function isInRing(p, ring) {
      return PointLocation.locateInRing(p, ring) !== Location.EXTERIOR;
    }
  }]);
  return PointLocation;
}();
export { PointLocation as default };